<template>
  <v-layout>
    <div v-if="loading">
      <spinner />
    </div>
    <v-flex v-else xs12 sm10 md8 class="form-container">
      <v-layout wrap>
        <v-flex xs12>
          <div v-if="$apollo.loading">
            <spinner />
          </div>
          <form v-scroll-to-error @submit.prevent="update">
            <v-flex class="screen-title">
              <span>{{ adminText('workflowsAll.email_details_f9c3a37', 'Email details') }}</span>
            </v-flex>
            <v-flex x4>
              <div class="title-description screen-description" />
            </v-flex>
            <v-flex style="margin-left: 12px">
              <div class="email-subject">{{ workflowLabel(form.subject || adminText('workflowsAll.no_subject_7b4e803', 'No subject')) }}</div>
              <div class="email-content" v-html="form.content" />
            </v-flex>
            <v-flex xs12>
              <main-button flat @click.prevent="goBack"> {{ adminText('workflowsAll.go_back_502bbc9', 'GO BACK') }} </main-button>
              <main-button class="mr-16" flat color="error" @click.prevent="deleteEmail">
                {{ adminText('workflowsAll.delete_d6f5636', 'DELETE') }}
              </main-button>
            </v-flex>
          </form>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs4 class="email-shortcodes">
      <email-recepients
        :event-id="selectedEventId"
        :reply-to="replyTo"
        :date-and-time="form.createdAt"
        :identifiers="identifiers"
        :not-sent-identifiers="notSentIdentifiers"
        :recipient-type="recipientType"
        :attendees="attendees"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import EmailRecepients from './email-recepients'
import { GET_EMAIL, DELETE_EMAIL } from '@/graphql/email.graphql'
import { GET_ALLOWED_ATTENDEES_BY_EVENT_ID } from '@/graphql/accreditation.graphql'

export default {
  mixins: [WorkflowDisplay],
  name: 'theater-email-details-container',
  components: {
    EmailRecepients,
  },
  props: {
    eventTemplateId: String,
    selectedEventId: String,
    emailId: String,
  },
  data() {
    return {
      form: {},
      replyTo: '',
      recipientType: '',
      attendees: [],
      identifiers: [],
      notSentIdentifiers: [],
      loading: true,
    }
  },
  methods: {
    async deleteEmail() {
      await this.$apollo.mutate({
        mutation: DELETE_EMAIL,
        variables: { emailId: this.emailId },
      })
      this.goTo(this.routes.theaterOrganizer.emailsTheater, {
        initiallySelectedEventId: this.selectedEventId,
      })
    },
  },
  apollo: {
    getAllowedAttendeesByEventId: {
      query: GET_ALLOWED_ATTENDEES_BY_EVENT_ID,
      variables() {
        return {
          eventId: this.selectedEventId,
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const { getAllowedAttendeesByEventId: attendees } = data
          this.attendees = attendees
        }
      },
    },
    getEmail: {
      query: GET_EMAIL,
      variables() {
        return {
          emailId: this.emailId,
        }
      },
      async result({ data, loading }) {
        if (!loading) {
          const {
            getEmail: {
              emailRecipient: { identifiers, recipientType, notSentIdentifiers },
              ...emailData
            },
          } = data
          this.form = emailData
          this.identifiers = identifiers
          this.recipientType = recipientType
          this.notSentIdentifiers = notSentIdentifiers
          this.loading = false
        }
      },
    },
  },
}
</script>

<style scoped>
.screen-description {
  max-width: 680px;
  margin-bottom: 28px;
}
.form-container {
  margin-right: 30px;
}
.email-shortcodes {
  margin: 130px -30px 0 0;
}
.email-subject {
  font-family: Raleway;
  font-size: 18px;
  font-weight: bold;
  color: #0277bd;
  margin-bottom: 16px;
}
.email-content {
  font-size: 16px;
  margin-bottom: 16px;
  word-break: break-all;
}

.email-content >>> .ql-size-small {
  font-size: 0.75em;
}

.email-content >>> .ql-size-large {
  font-size: 1.5em;
}

.email-content >>> .ql-size-huge {
  font-size: 2.5em;
}
</style>
